import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import {
  Done as IconVerified,
  ThumbDownAlt as IconReject,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";

import {
  API_CONFIG,
  CONFIG,
  CRM_LEAD_STATUS,
  DOC_UPLOAD_STATUS,
  NOTIFY,
} from "common/config";
import { COMMON_JS } from "common/scripts";
import { ERRORS, SUCCESS, WARNINGS } from "common/lables";
import { CRM_APIs } from "apihandlers/crm";
import { AUTH_APIs } from "apihandlers/auth";
import Btn from "components/Custom/Btn";

interface defaultProps {}

const DocVerification = (props: any) => {
  const { selectedRow, onClose } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [uploadFiles, setUploadFiles] = useState<any>([]);
  const [column, setColumn] = useState<any>([
    {
      key: "crmDocumentName",
      name: "Document",
      type: "text",
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "files",
      name: "Files",
      width: "50%",
      editable: false,
      sortable: true,
      align: "center",
      renderCell: ({ row }: any) => {
        return row.files;
      },
    },
    {
      key: "status",
      name: "Status",
      width: "30%",
      editable: false,
      sortable: false,
      align: "center",
    },
  ]);
  const [rows, setRows] = useState<any>(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const onUploadFile = (e: any, row: any) => {
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setUploadFiles(null);
      uploadFile(file, base64, row.id).then((res) => {
        setUploadFiles([res]);
        getRows();
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "", docId = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "crm",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        manageCrmLeadDoc(fileInfo.id, docId);
      }
    } catch (error) {
      console.error(error);
    }
    return fileInfo;
  };

  const manageCrmLeadDoc = async (
    fileId,
    docId,
    status = DOC_UPLOAD_STATUS.UPLOADED,
    id = null
  ) => {
    const args = {
      id: id || -1,
      crmLeadId: selectedRow.id,
      docId: docId,
      documentStatus: status,
      fileId,
    };
    CRM_APIs.manageCrmLeadDocument(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        getRows();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {};
      setRows(null);
      const res: any = await CRM_APIs.getCrmDocuments(args);
      const { status, response } = res;
      if (status === 200) {
        getCrmLeadDocuments(res.response.records);
      }
    } catch (error) {
      console.error("getCrmDocuments:", error);
    }
  };

  const getCrmLeadDocuments = async (list: any) => {
    const args = { crmLeadId: selectedRow.id };
    const res: any = await CRM_APIs.getCrmLeadDocuments(args);
    if (res.status === 200) {
      const recs = res.response.records;
      for (let i = 0; i < list.length; i++) {
        if (list[i].isDocMandatory) {
          list[i].crmDocumentName = (
            <span className="red">{list[i].crmDocumentName + " *"}</span>
          );
        }
        const docFiles = recs.filter((r: any) => r.docId === list[i].id);
        const docFile =
          docFiles.length > 0 ? docFiles[docFiles.length - 1] : {};
        list[i].files = (
          <div className="flexRow">
            <div style={{ width: "40%" }}>
              <TxtBox
                type={"file"}
                id={"uploadFile-" + i}
                accept="image/*,.pdf"
                onChange={(e) => onUploadFile(e, list[i])}
              />
            </div>
            <div
              style={{
                marginLeft: 10,
                width: "60%",
                overflow: "auto",
                display: "flex",
              }}
            >
              {docFiles.map((d: any) => {
                const fileUrl = API_CONFIG.STATIC_URL + d.path;
                return (
                  <img
                    onClick={() => {
                      window.open(fileUrl, "_blank");
                    }}
                    src={fileUrl}
                    width={"auto"}
                    height={50}
                    style={{ marginRight: 5 }}
                  />
                );
              })}
            </div>
          </div>
        );
        const isVerified =
          docFile.documentStatus &&
          docFile.documentStatus === DOC_UPLOAD_STATUS.UPLOADED;
        const isRejected =
          docFile.documentStatus &&
          docFile.documentStatus === DOC_UPLOAD_STATUS.UPLOADED;
        list[i].status = (
          <div className="flexRow" style={{ margin: "auto", display: "block" }}>
            {docFile.documentStatus && (
              <Chip
                label={docFile.documentStatus}
                color={"success"}
                disabled={true}
                style={{ marginLeft: "10px" }}
                className={
                  "chipBtn " +
                  (docFile.documentStatus === DOC_UPLOAD_STATUS.VERIFIED
                    ? "green"
                    : docFile.documentStatus === DOC_UPLOAD_STATUS.REJECTED
                    ? "red"
                    : "limeGreen")
                }
              />
            )}
            {isVerified && (
              <Chip
                label={DOC_UPLOAD_STATUS.VERIFIED}
                disabled={false}
                clickable={true}
                icon={<IconVerified />}
                style={{ marginLeft: "10px" }}
                className={"chipBtn"}
                onClick={() => {
                  manageCrmLeadDoc(
                    docFile.fileId,
                    list[i].id,
                    DOC_UPLOAD_STATUS.VERIFIED,
                    docFile.id
                  );
                }}
              />
            )}
            {isRejected && (
              <Chip
                label={DOC_UPLOAD_STATUS.REJECTED}
                disabled={false}
                clickable={true}
                icon={<IconReject />}
                style={{ marginLeft: "10px" }}
                className={"chipBtn"}
                onClick={() => {
                  manageCrmLeadDoc(
                    docFile.fileId,
                    list[i].id,
                    DOC_UPLOAD_STATUS.REJECTED,
                    docFile.id
                  );
                }}
              />
            )}
          </div>
        );
      }
    }
    setRows(list);
    setLoading(false);
  };

  const onDocVerified = async () => {
    try {
      const args = {
        crmLeadId: selectedRow.id,
        crmLeadName: selectedRow.crmLeadName,
        activeStatus: "true",
        crmLeadStatus: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
      };
      const res = await CRM_APIs.manageCrmLeadProfile(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
    } catch (error) {
      console.error("onConverted: ", error);
    }
  };

  return (
    <React.Fragment>
      {rows ? (
        <>
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={column}
            rows={rows}
            exportOption={false}
            newRowOption={false}
            onReload={getRows}
          />
          <div
            className="flexColumn"
            style={{
              alignItems: "center",
              marginTop: "2rem",
            }}
          >
            <div
              className="flexRow"
              style={{ width: "20%", justifyContent: "center" }}
            >
              <Btn
                text={CRM_LEAD_STATUS.DOCUMENT_VERIFICATION}
                style={{ width: "100%" }}
                onClick={onDocVerified}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="flexRowCenter">
          <Loader />
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(DocVerification);
